import React from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { adminSession } from '../../services/adminApi';
import AdminLoginPage from './AdminLoginPage';
import AdminLayout from './AdminLayout';
import AdminOverview from './AdminOverview';
import AdminUsersPage from './AdminUsersPage';
import AdminSubscriptionPage from './AdminSubscriptionPage';
import AdminPaymentsPage from './AdminPaymentsPage';
import AdminSystemPage from './AdminSystemPage';

const AdminGuard: React.FC = () => {
  const user = adminSession.getUser();
  const roleOk = user?.role === 'ADMIN' || user?.role === 'SUPER_ADMIN';
  if (!adminSession.isLoggedIn() || !roleOk) {
    adminSession.clear();
    return <Navigate to='/login' replace />;
  }
  return <Outlet />;
};

const AdminRoutes: React.FC = () => (
  <Routes>
    <Route path='/login' element={<AdminLoginPage />} />

    {/* Guarded area with shared responsive layout */}
    <Route element={<AdminGuard />}>
      <Route element={<AdminLayout />}>
        <Route path='/overview' element={<AdminOverview />} />
        <Route path='/users' element={<AdminUsersPage />} />
        <Route path='/subscription' element={<AdminSubscriptionPage />} />
        <Route path='/payments' element={<AdminPaymentsPage />} />
        <Route path='/system' element={<AdminSystemPage />} />
      </Route>
    </Route>

    <Route path='/' element={<Navigate to='/overview' replace />} />
    <Route path='*' element={<Navigate to='/overview' replace />} />
  </Routes>
);

export default AdminRoutes;
